"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _panel = _interopRequireDefault(require("../panel"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _CodeEditor = _interopRequireDefault(require("@insided/shared/uikit/CodeEditor"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _api = require("../../utils/api");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ThirdPartyScripts = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ThirdPartyScripts, _Component);

  var _super = _createSuper(ThirdPartyScripts);

  function ThirdPartyScripts() {
    var _this;

    (0, _classCallCheck2.default)(this, ThirdPartyScripts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      head: '',
      bodyStart: '',
      bodyEnd: '',
      ssiUrl: '',
      message: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSave", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                message: '',
                isLoading: true
              });

              _context.prev = 1;
              _context.next = 4;
              return (0, _api.updateThirdPartyScriptConfig)(_this.state);

            case 4:
              _context.next = 11;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

              _this.setState({
                message: 'error',
                isLoading: false
              });

              return _context.abrupt("return");

            case 11:
              _this.setState({
                message: 'success',
                isLoading: false
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(ThirdPartyScripts, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this;
                _context2.next = 3;
                return (0, _api.getThirdPartyScriptConfig)();

              case 3:
                _context2.t1 = _context2.sent;

                _context2.t0.setState.call(_context2.t0, _context2.t1);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          head = _this$state.head,
          bodyStart = _this$state.bodyStart,
          ssiUrl = _this$state.ssiUrl,
          bodyEnd = _this$state.bodyEnd,
          message = _this$state.message,
          isLoading = _this$state.isLoading;
      var headText = 'Add Scripts in the <HEAD>. Adding scripts to the <HEAD> may impact the performance and loading time of your community. Use for scripts needed in Head, like third-party libraries, metadata, or fonts.';
      var bodyStartText = 'Add Scripts at the top of <BODY>. Use for scripts that should run early in the body, such as analytics or tag managers.';
      var bodyEndText = 'Add Scripts at the bottom of <BODY>. Use for scripts that should load after the main body content e.g., widgets, chatbots, or deferred JS.';
      return (0, _preact.h)("div", {
        className: "third-party-scripts"
      }, (0, _preact.h)(_header.default, {
        isLoading: isLoading,
        title: "Third-party Scripts",
        saveCallback: this.onSave
      }), message !== '' ? (0, _preact.h)(_AlertComponent.default, {
        messageType: message,
        isVisibleFor: 3000
      }) : null, (0, _preact.h)("div", {
        className: "alert alert-info"
      }, (0, _preact.h)("p", null, (0, _preact.h)("strong", null, "Note:"), " We recommend inviting a professional web developer to work with custom code. Insert code at your own risk, and proceed with extreme caution \u2014 inSided support won't be able to assist you with custom code issues. If you want to test your code before publishing we strongly recommend you to use your staging environment first.")), (0, _preact.h)(_panel.default, {
        customClass: "third-party-scripts",
        title: "Insert in <HEAD>"
      }, (0, _preact.h)("p", null, headText), (0, _preact.h)(_CodeEditor.default, {
        defaultValue: head,
        onChange: function onChange(newData) {
          return _this2.setState({
            head: newData
          });
        },
        className: "customCss__form-textarea",
        options: {
          mode: 'text/html'
        }
      }), (0, _preact.h)("div", {
        className: "third-party-scripts_ssi-url-wrapper"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "SSI URL",
        qaClasses: "third-party-scripts_ssi-url",
        type: "text",
        onChange: function onChange(e) {
          return _this2.setState({
            ssiUrl: e.target.value
          });
        },
        value: ssiUrl
      }))), (0, _preact.h)(_panel.default, {
        customClass: "third-party-scripts",
        title: "INSERT RIGHT AFTER <BODY> TAG"
      }, (0, _preact.h)("p", null, bodyStartText), (0, _preact.h)(_CodeEditor.default, {
        defaultValue: bodyStart,
        onChange: function onChange(newData) {
          return _this2.setState({
            bodyStart: newData
          });
        },
        className: "customCss__form-textarea",
        options: {
          mode: 'text/html'
        }
      })), (0, _preact.h)(_panel.default, {
        customClass: "third-party-scripts",
        title: "INSERT BEFORE </BODY> TAG"
      }, (0, _preact.h)("p", null, bodyEndText), (0, _preact.h)(_CodeEditor.default, {
        defaultValue: bodyEnd,
        onChange: function onChange(newData) {
          return _this2.setState({
            bodyEnd: newData
          });
        },
        className: "customCss__form-textarea",
        options: {
          mode: 'text/html'
        }
      })));
    }
  }]);
  return ThirdPartyScripts;
}(_preact.Component);

var _default = ThirdPartyScripts;
exports.default = _default;